import * as api from 'app/shared/api';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/AgentSearch/actionTypes';
import { changeSearchTerm, changeSearchStatus, agentSearchResult } from 'app/pages/AgentSearch/actions';
import { AgentSearchStatus } from 'app/pages/AgentSearch/modules/AgentItemsList/state';
import { getSearchTerm } from 'app/pages/AgentSearch/modules/AgentItemsList';

export function runAgentSearch(searchTerm: string) {
    return function(dispatch: ThunkDispatch<any, any, Action>, getState: () => any) {
        dispatch(changeSearchTerm(searchTerm));

        if (searchTerm.trim() === '') {
            dispatch(agentSearchResult([]));
            return;
        }

        dispatch(changeSearchStatus(AgentSearchStatus.Running));
        api.searchAgents(searchTerm, false, 50)
            .then(x => {
                if (getSearchTerm(getState()) !== searchTerm)
                    return;
                dispatch(agentSearchResult(x));
            })
            .catch(x => {
                if (getSearchTerm(getState()) !== searchTerm)
                    return;
                dispatch(changeSearchStatus(AgentSearchStatus.Errored));
            });
    }
}